import { render, staticRenderFns } from "./ShowDetailsDialog.vue?vue&type=template&id=3e48f746"
import script from "./ShowDetailsDialog.vue?vue&type=script&lang=js"
export * from "./ShowDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports